// extracted by mini-css-extract-plugin
export default {"container":"Plans_container__HmiFu","heading":"Plans_heading__VmW84","plans":"Plans_plans__vBb-F"};